import React from 'react';
import './WavingHand.css';

/**
 * Animated waving hand icon - language independent replacement for icon_roep.png
 * White/cream colored to stand out on red button
 */
function WavingHand({ onClick, className = '' }) {
    return (
        <div className={`waving-hand-container ${className}`} onClick={onClick}>
            <svg
                viewBox="0 0 100 100"
                className="waving-hand-svg"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                {/* Hand - white colored for visibility on red button */}
                <g className="hand-group">
                    {/* Palm base - centered */}
                    <ellipse cx="50" cy="65" rx="22" ry="18" fill="white" stroke="#e8ddd4" strokeWidth="1.5"/>

                    {/* Thumb - left side */}
                    <path
                        d="M28 58 Q22 52 24 44 Q26 38 32 41 Q37 44 33 56"
                        fill="white"
                        stroke="#e8ddd4"
                        strokeWidth="1.5"
                    />

                    {/* Index finger */}
                    <rect x="33" y="26" width="10" height="32" rx="5" fill="white" stroke="#e8ddd4" strokeWidth="1.5"/>

                    {/* Middle finger - tallest */}
                    <rect x="45" y="22" width="10" height="36" rx="5" fill="white" stroke="#e8ddd4" strokeWidth="1.5"/>

                    {/* Ring finger */}
                    <rect x="57" y="26" width="10" height="32" rx="5" fill="white" stroke="#e8ddd4" strokeWidth="1.5"/>

                    {/* Pinky finger - smaller, closer to ring finger */}
                    <rect x="68" y="34" width="8" height="24" rx="4" fill="white" stroke="#e8ddd4" strokeWidth="1.5"/>
                </g>
            </svg>
        </div>
    );
}

export default WavingHand;
